import styled from "styled-components";
import {rem} from 'polished';

const FontFamilyMulish = ({theme: {$fontFamilyMulish}}) => `${$fontFamilyMulish}`;

const baseFont = `12px`;
const S = {};

S.BetSlipBonusWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: #09256D;
  padding: 10px 20px 10px 20px;
`;

S.BetSlipBonusOptionLabel = styled.label`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

S.BetslipBonusLabel = styled.div`
  color: #FFFFFF;
  font-weight: 400;
  font-family: ${FontFamilyMulish};
  font-size: ${rem('11px', baseFont)};
`;

export default S;